import { POST_BUILDER } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import PostBuilderPage from "./container/PostBuilderPage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: POST_BUILDER,
    withSidebar: false,
    withAppBar: false,
    component: PostBuilderPage,
  };
}
